import * as React from 'react';

function SvgReferralRemove(props) {
  return (
    <svg width={22} height={22} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx={11} cy={11} r={10} fill="#fff" stroke="#BFBFBF" />
      <path stroke="#BFBFBF" strokeLinecap="round" d="M6.5 10.5h9" />
    </svg>
  );
}

export default SvgReferralRemove;
